<template>
  <div>
    <b-notification :has-icon="true" icon="file" :closable="false">
      {{ $t('compCarbonFormsDevicesHelpFileFormat.info-1') }}
      <a class="link" href="/static/carbon/devicesTemplate.tsv" download>{{
        $t('compCarbonFormsDevicesHelpFileFormat.info-3')
      }}</a>
      {{ $t('compCarbonFormsDevicesHelpFileFormat.info-3a') }}
      <a class="link" href="/static/carbon/devicesTemplate.csv" download>{{
        $t('compCarbonFormsDevicesHelpFileFormat.info-3b')
      }}</a
      >).
      {{ $t('compCarbonFormsDevicesHelpFileFormat.info-4') }}
      <br /><br />
      <ul style="list-style-type: square; margin-left: 25px">
        <li v-html="$t('compCarbonFormsDevicesHelpFileFormat.info-5')"></li>
        <li v-html="$t('compCarbonFormsDevicesHelpFileFormat.info-6')"></li>
        <li v-html="$t('compCarbonFormsDevicesHelpFileFormat.info-7')"></li>
        <li v-html="$t('compCarbonFormsDevicesHelpFileFormat.info-8')"></li>
      </ul>
      <p v-html="$t('compCarbonFormsDevicesHelpFileFormat.info-9')"></p>
    </b-notification>
  </div>
</template>

<script>
export default {
  name: 'HelpFileFormat'
}
</script>
